export const GET_PROFILE_NAME_SUCCESS = '[PROFILE][FETCH][NAME] success get profile name';
export const GET_PROFILE_DETAIL_SUCCESS = '[PROFILE][FETCH][DETAIL] success get profile';
export const LOADING_PROFILE = '[PROFILE][LOADING][DETAIL] set loading profile';

const json = {
  GET_PROFILE_NAME_SUCCESS,
  GET_PROFILE_DETAIL_SUCCESS,
  LOADING_PROFILE,
};

export default json;
